import React from 'react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
    return (
        <div id="aboutpage" className="container py-5 mt-4">
            {/* Hero Section */}
            <div className="about-hero text-center mb-5">
                <div className="d-flex justify-content-center mb-3">
                    <img src="/logo.png" alt="FamilyTopUp" width="90" height="90" className="rounded-circle shadow" />
                </div>
                <h1 className="about-main-title">Tentang <span className="about-highlight">FamilyTopUp</span></h1>
                <p className="about-subtitle">Platform Top-Up Game &amp; Voucher Digital Terpercaya di Indonesia</p>
            </div>

            {/* Deskripsi */}
            <div className="row justify-content-center mb-5">
                <div className="col-lg-8">
                    <div className="about-card">
                        <h5 className="about-section-title"><i className="bi bi-info-circle-fill me-2"></i>Siapa Kami?</h5>
                        <p className="about-text">
                            <strong>FamilyTopUp</strong> adalah platform layanan top-up game dan pembelian voucher digital yang 
                            beroperasi secara penuh otomatis 24 jam sehari, 7 hari seminggu. Kami hadir untuk memudahkan 
                            para gamer Indonesia dalam mengisi saldo, diamond, dan berbagai mata uang dalam game favorit mereka 
                            dengan harga yang kompetitif, proses yang cepat, dan transaksi yang aman.
                        </p>
                        <p className="about-text">
                            Kami berkomitmen memberikan pengalaman berbelanja digital yang menyenangkan, transparan, 
                            dan terpercaya untuk seluruh keluarga gamer Indonesia.
                        </p>
                    </div>
                </div>
            </div>

            {/* Keunggulan */}
            <h4 className="text-center fw-bold mb-4">Mengapa Memilih FamilyTopUp?</h4>
            <div className="row g-4 mb-5 justify-content-center">
                <div className="col-lg-3 col-md-6">
                    <div className="about-feature-card text-center">
                        <div className="about-feature-icon"><i className="bi bi-lightning-charge-fill"></i></div>
                        <h6 className="fw-bold mt-3">Proses Cepat</h6>
                        <p className="small text-muted">Top-up diproses otomatis dalam hitungan detik, tanpa perlu menunggu konfirmasi admin.</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="about-feature-card text-center">
                        <div className="about-feature-icon"><i className="bi bi-shield-check-fill"></i></div>
                        <h6 className="fw-bold mt-3">Transaksi Aman</h6>
                        <p className="small text-muted">Pembayaran diproses melalui Xendit, payment gateway terpercaya dan berlisensi OJK.</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="about-feature-card text-center">
                        <div className="about-feature-icon"><i className="bi bi-clock-fill"></i></div>
                        <h6 className="fw-bold mt-3">Layanan 24 Jam</h6>
                        <p className="small text-muted">Sistem kami beroperasi penuh 24 jam. Top-up kapan saja, di mana saja tanpa batas waktu.</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="about-feature-card text-center">
                        <div className="about-feature-icon"><i className="bi bi-tags-fill"></i></div>
                        <h6 className="fw-bold mt-3">Harga Terjangkau</h6>
                        <p className="small text-muted">Harga kompetitif dengan berbagai pilihan metode pembayaran yang fleksibel untuk semua.</p>
                    </div>
                </div>
            </div>

            {/* Kontak */}
            <div className="row justify-content-center mb-5">
                <div className="col-lg-8">
                    <div className="about-card">
                        <h5 className="about-section-title"><i className="bi bi-headset me-2"></i>Hubungi Kami</h5>
                        <div className="d-flex flex-column gap-3">
                            <a href="mailto:topupfamily30@gmail.com" className="about-contact-link">
                                <i className="bi bi-envelope-fill me-3"></i>topupfamily30@gmail.com
                            </a>
                            <a href="https://wa.me/628131091521" target="_blank" rel="noreferrer" className="about-contact-link">
                                <i className="bi bi-whatsapp me-3"></i>WhatsApp: 0813-1091-521
                            </a>
                            <p className="small text-muted mb-0 mt-1">
                                <i className="bi bi-clock me-2"></i>
                                Customer Service aktif setiap hari pukul <strong>09:00 – 20:00 WIB</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Back Button */}
            <div className="text-center">
                <Link to="/" className="btn btn-outline-secondary px-4">
                    <i className="bi bi-arrow-left me-2"></i>Kembali ke Beranda
                </Link>
            </div>
        </div>
    );
};

export default AboutPage;
